<template>
  <div class='wrap'>
    <div class='line'>
      <div>
        <span class='title'>{{ $t('pc-biz-sp-pubtime') }}</span>
        <yxt-date-picker
          v-model='publishTime'
          @change='onPublishTime'
          size='large'
          type='daterange'
          :placeholder='$t("pc-biz-sp-timesle")'>
        </yxt-date-picker>
      </div>
      <div>
        <span class='title'>{{ $t('pc-biz-sp-starttime') }}</span>
        <yxt-date-picker
          v-model='startTime'
          @change='onStartTime'
          size='large'
          type='daterange'
          :placeholder='$t("pc-biz-sp-timesle")'>
        </yxt-date-picker>
      </div>
    </div>
    <div class='line'>
      <div>
        <span class='title'>{{ $t('pc-biz-sp-overtime') }}</span>
        <yxt-date-picker
          v-model='endTime'
          @change='onEndTime'
          size='large'
          type='daterange'
          :placeholder='$t("pc-biz-sp-timesle")'>
        </yxt-date-picker>
      </div>
      <div>
        <span class='title'>{{ $t('pc-biz-sp-pjstatus') }}</span>
        <yxt-select v-model='searchParams.status' clearable :placeholder='$t("pc-biz-sp-plselect")' size='large' @change='onStatus'>
          <yxt-option
            v-for='item in options'
            :key='item.value'
            :label='item.label'
            :value='item.value'
          >
          </yxt-option>
        </yxt-select>
      </div>
    </div>
    <div class='line category'>
      <div>
        <span class='title'>{{ $t('pc-biz-sp-pjcategroy') }}</span>
        <CategoriesSelector :select-width='240' @clear='categoryClear' @change='categoryChange' />
      </div>
    </div>
  </div>
</template>
<script>

import CategoriesSelector from './categoriesSelector.vue';

export default {
  name: 'MoreFilter',
  components: {
    CategoriesSelector
  },
  data() {
    return {
      publishTime: '',
      startTime: '',
      endTime: '',
      options: [{ value: 1, label: this.$t('pc-biz-sp-published') }, { value: 3, label: this.$t('pc-biz-sp-over') }],
      searchParams: {
        categoryId: '', // 分类的ID
        status: '', // 0：未发布，1：已发布,2:已撤销,3.已结束
        projectPublishStartTime: '',
        projectPublishEndTime: '',
        projectStartStartTime: '',
        projectStartEndTime: '',
        projectEndStartTime: '',
        projectEndEndTime: ''
      }
    };
  },
  methods: {
    formatNum(num) {
      return num < 10 ? '0' + num : num;
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return year + '-' + this.formatNum(month) + '-' + this.formatNum(day);
    },
    categoryClear() {
      this.searchParams.categoryId = '';
      this.$emit('filter-change');
    },
    categoryChange(id) {
      this.searchParams.categoryId = id;
      this.$emit('filter-change');
    },
    onPublishTime() {
      this.searchParams.projectPublishStartTime = this.publishTime && this.formatDate(this.publishTime[0]);
      this.searchParams.projectPublishEndTime = this.publishTime && this.formatDate(this.publishTime[1]);
      this.$emit('filter-change');
    },
    onStartTime() {
      this.searchParams.projectStartStartTime = this.startTime && this.formatDate(this.startTime[0]);
      this.searchParams.projectStartEndTime = this.startTime && this.formatDate(this.startTime[1]);
      this.$emit('filter-change');
    },
    onEndTime() {
      this.searchParams.projectEndStartTime = this.endTime && this.formatDate(this.endTime[0]);
      this.searchParams.projectEndEndTime = this.endTime && this.formatDate(this.endTime[1]);
      this.$emit('filter-change');
    },
    onStatus() {
      this.$emit('filter-change');
    }
  }
};
</script>

<style lang='scss' scoped>
.wrap {
}

.line {
  display: flex;
  align-items: center;
  padding-bottom: 16px;

  > div {
    flex: 1;
  }
}

.title {
  display: block;
  padding: 0 0 6px 0;
}
</style>
